import React from "react";
import { LINKS } from "@consts";
import ErrorPage from "./ErrorPage";
import InternalErrorIcon from "./InternalErrorIcon";

const InternalErrorPage = () => {
  const pageLinks = [
    { url: window.location.pathname, text: "Reload" },
    { url: LINKS.HYRO_SUPPORT, text: "Contact support" }
  ];

  return (<ErrorPage
    code="500"
    message="An error occurred"
    explanation="This page isn’t working"
    links={pageLinks}
    Icon={InternalErrorIcon}
  />);
};

export default InternalErrorPage;
